import React from 'react';
import UserAvatar from '../userAvatar/UserAvatar'
import UserTitle from './UserTitle'
import Impersonation from './Impersonation'
import { Link, withRouter } from 'react-router-dom';
import * as App from 'modules/app/App';

const classNames = require('classnames');

class UserCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false }
    }

    onSignOut = () => {
        // Logout
        App.logout();

        // Redirect
        window.location.href = "/";
    }

    onImpersonation = () => {
        this.props.history.push('/accounts/impersonation');
    }

    onRevertImpersonation = () => {
        App.revertImpersonation();
    }

    toggleVisibility = () => {
        this.setState({ open: !this.state.open })
    }

    render() {
        const context = App.context();

        return (
            <div className="navbar-custom-menu">
                <ul className="nav navbar-nav">
                    <li className={classNames({ dropdown: true, open: this.state.open })} onMouseEnter={this.toggleVisibility}
                        onMouseLeave={this.toggleVisibility}>
                        <a style={{ cursor: "pointer" }}>
                            <UserAvatar
                                userId={context.userId}
                                style={{ width: "30px", height: "30px", marginTop: "-10px", marginBottom: "-10px", border: "0px" }} />
                        </a>
                        <ul className="dropdown-menu c-user-card">
                            <li className="c-user-card__header">
                                <UserAvatar userId={context.userId} />
                                <p className="c-user-card__title">
                                    <UserTitle />
                                    <small className="c-user-card__subtitle">{context.login}</small>
                                    <small className="c-user-card__subtitle">{context.email}</small>
                                </p>

                                <Impersonation onImpersonation={this.onImpersonation} onRevertImpersonation={this.onRevertImpersonation} />
                            </li>
                            <li className="c-user-card__header">
                                <div className="pull-left">
                                    <Link to="/accounts/profile#ProfileTab" className="btn btn-default btn-flat">My Profile</Link>
                                </div>
                                <div className="pull-right">
                                    <a className="btn btn-default btn-flat" onClick={this.onSignOut}>Sign out</a>
                                </div>
                                <div className="clearfix"></div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        );
    }
}

export default withRouter(UserCard);



// WEBPACK FOOTER //
// ./src/layouts/main/userCard/UserCard.js